import { render, staticRenderFns } from "./CrmResourceTree.vue?vue&type=template&id=386c6d31&scoped=true&"
import script from "./CrmResourceTree.vue?vue&type=script&lang=js&"
export * from "./CrmResourceTree.vue?vue&type=script&lang=js&"
import style0 from "./CrmResourceTree.vue?vue&type=style&index=0&id=386c6d31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c6d31",
  null
  
)

export default component.exports